import {service as SpeciesListTypeService} from "../../Services/SpeciesListTypeService";
import {service as SpeciesNativityService} from "../../Services/SpeciesNativityService";
import {service as SpeciesInvasivityService} from "../../Services/SpeciesInvasivityService";
import {service as SpeciesTypeService} from "../../Services/SpeciesTypeService";
import {service as SpeciesRequestStatusService} from "../../Services/SpeciesRequestStatusService";
import {service as SpeciesRequestSourceService} from "../../Services/SpeciesRequestSourceService";
import {service as SpeciesListService} from "../../Services/SpeciesListService";

import {ServiceDrivenDropDownFieldEditor} from "./FieldEditors/ServiceDrivenDropDownFieldEditor";
import {ServiceDrivenFieldViewer} from "./FieldViewers/ServiceDrivenFieldViewer";
import {ServiceDrivenCheckboxesFieldEditor} from "./FieldEditors/ServiceDrivenCheckboxesFieldEditor";

export const SpeciesListTypeFieldViewer = ServiceDrivenFieldViewer(SpeciesListTypeService);
export const SpeciesListTypeFieldEditor = ServiceDrivenDropDownFieldEditor(SpeciesListTypeService);

export const SpeciesInvasivityFieldViewer = ServiceDrivenFieldViewer(SpeciesInvasivityService);
export const SpeciesNativityFieldViewer = ServiceDrivenFieldViewer(SpeciesNativityService);
export const SpeciesTypeFieldViewer = ServiceDrivenFieldViewer(SpeciesTypeService);
export const SpeciesRequestStatusFieldViewer = ServiceDrivenFieldViewer(SpeciesRequestStatusService);
export const SpeciesRequestSourceFieldViewer = ServiceDrivenFieldViewer(SpeciesRequestSourceService);

export const SpeciesInvasivityFieldEditor = ServiceDrivenDropDownFieldEditor(SpeciesInvasivityService);
export const SpeciesNativityFieldEditor = ServiceDrivenDropDownFieldEditor(SpeciesNativityService);
export const SpeciesTypeFieldEditor = ServiceDrivenDropDownFieldEditor(SpeciesTypeService);
// export const SpeciesRequestStatusFieldEditor = ServiceDrivenDropDownFieldEditor(SpeciesRequestStatusService);
// export const SpeciesRequestSourceFieldEditor = ServiceDrivenDropDownFieldEditor(SpeciesRequestSourceService);

export const SpeciesListCheckboxFieldEditor = ServiceDrivenCheckboxesFieldEditor(SpeciesListService);